import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "EmbedManager" })
export default class CookieToast extends Vue {
    @Prop() readonly mode: string;
    @Prop() readonly isWebPages: boolean;
    @Prop() readonly isEmbed: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    private async created() {
        if (this.isIFrame()) {
            if (this.mode !== "Embed") {
                window.location.href = this.routes.Documentation_DocumentationNotAvailable;
            }
        } else {
            if (this.mode === "Embed") {
                window.location.href = this.routes.Documentation_DocumentationNotAvailable;
            }
        }
    }

    private isIFrame(): boolean {
        return window.location !== window.parent.location;
    }
};